import { render, staticRenderFns } from "./TestingOrganizationForm.vue?vue&type=template&id=0ffa3ae6&scoped=true"
import script from "./TestingOrganizationForm.vue?vue&type=script&lang=ts"
export * from "./TestingOrganizationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa3ae6",
  null
  
)

export default component.exports